<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">{{options?.title}}</h4>
</div>
<div class="form-group modal-body">
  <p [innerHTML]="$safeNavigationMigration(options?.body)"></p>
  @if (!options?.multiline) {
    <div class="form-group">
      <input autocomplete="other" name="pwd4pfx" [attr.type]="options.type" class="form-control" (keyup.enter)="ok()" [(ngModel)]="inputValue" [bizFocus]="true" />
    </div>
  }
  @if (options?.multiline) {
    <div class="form-group">
      <textarea class="form-control" name="value" [cols]="$safeNavigationMigration(options?.multilineColumns)" [rows]="$safeNavigationMigration(options?.multilineRows)" [(ngModel)]="inputValue" autofocus></textarea>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="ok()">{{options?.okButtonText || 'Ok'}}</button>
  <button type="button" class="btn btn-link" (click)="close()">{{options?.cancelButtonText || 'Cancel'}}</button>
</div>
